import { BaseDto } from "@models/base/baseDto.model"

export class UpdatePermisoRequest extends BaseDto{
  public token?: string
  public id_CasoUso?: number
  public id_Rol?: number
}
